import { IconImageOutline } from '@picsart/design-system/foundation/icons/IconImageOutline';
import { IconCross } from '@picsart/design-system/foundation/icons/IconCross';
import { ViewControls } from '@/sections/Header/ViewControls/ViewControls';
import useStyles from './styles';

import type { SizeValue } from '@/components/shared/SizeSelector';

interface HeaderRightProps {
  isAuthorized: boolean | undefined;
  showViewControls: boolean;
  showGenerationsButton: boolean;
  viewCrop: boolean;
  viewSize: SizeValue;
  onLogin: () => void;
  onCropToggle: () => void;
  onSizeChange: (size: SizeValue) => void;
  onGenerationsClick: () => void;
  onCloseApp: () => void;
}

export const HeaderRight = ({
  isAuthorized,
  showViewControls,
  showGenerationsButton,
  viewCrop,
  viewSize,
  onLogin,
  onCropToggle,
  onSizeChange,
  onGenerationsClick,
  onCloseApp,
}: HeaderRightProps) => {
  const classes = useStyles();

  return (
    <div className={classes.right}>
      {/* Login button - shown when not authorized */}
      {!isAuthorized && (
        <button
          type="button"
          className={classes.loginButton}
          onClick={onLogin}
          title="Log in"
          aria-label="Log in"
        >
          Log in
        </button>
      )}
      {/* View controls - mobile only, library screen */}
      {showViewControls && (
        <ViewControls
          viewCrop={viewCrop}
          viewSize={viewSize}
          onCropToggle={onCropToggle}
          onSizeChange={onSizeChange}
        />
      )}
      {/* Generations button - CSS hides on desktop */}
      {showGenerationsButton && (
        <button
          type="button"
          className={classes.generationsButton}
          onClick={onGenerationsClick}
          title="Your Creations"
          aria-label="Your Creations"
        >
          <IconImageOutline fill="currentColor" />
        </button>
      )}
      {/* Close button - CSS hides on desktop */}
      <button
        type="button"
        className={classes.closeButton}
        onClick={onCloseApp}
        title="Close"
        aria-label="Close app"
      >
        <IconCross fill="currentColor" width="20" height="20" />
      </button>
    </div>
  );
};
